import { render, staticRenderFns } from "./DoctorTargetPicker.vue?vue&type=template&id=a8f0041c&scoped=true"
import script from "./DoctorTargetPicker.vue?vue&type=script&lang=js"
export * from "./DoctorTargetPicker.vue?vue&type=script&lang=js"
import style0 from "./DoctorTargetPicker.vue?vue&type=style&index=0&id=a8f0041c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f0041c",
  null
  
)

export default component.exports